export interface Category {
  id: number;
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { id: 1, name: '电影', slug: 'movie', icon: 'ri-movie-2-line', description: '最新大片、经典佳作、院线热映', count: 2 },
  { id: 2, name: '电视剧', slug: 'drama', icon: 'ri-tv-2-line', description: '热播剧集、经典回顾、全网追剧', count: 2 },
  { id: 3, name: '综艺', slug: 'variety', icon: 'ri-emotion-laugh-line', description: '爆笑综艺、真人秀、音乐竞演', count: 1 },
  { id: 4, name: '动漫', slug: 'anime', icon: 'ri-palette-line', description: '热血动漫、国产动画、日漫经典', count: 2 },
  { id: 5, name: '纪录片', slug: 'documentary', icon: 'ri-earth-line', description: '自然探索、人文历史、科学解密', count: 2 },
  { id: 6, name: '音乐', slug: 'music', icon: 'ri-music-line', description: 'MV精选、演唱会、音乐节目', count: 1 },
  { id: 7, name: '游戏', slug: 'gaming', icon: 'ri-gamepad-line', description: '赛事集锦、游戏解说、攻略教程', count: 1 },
  { id: 8, name: '体育', slug: 'sports', icon: 'ri-basketball-line', description: '赛事直播、精彩集锦、体育资讯', count: 1 },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find(c => c.slug === slug);
}